import { createContext } from 'react'

export interface LoadingStateContextValue {
  registerLoadingState: (name: string, isLoading: boolean) => void
  unregisterLoadingState: (name: string) => void
  isLoading: boolean
  isGlobalLoaderActive: boolean
}

export const LoadingStateContext = createContext<LoadingStateContextValue | undefined>(undefined)
